import { z } from 'zod';

export const FileKind = z.enum(['logo', 'receipt_image', 'task_photo', 'statement_pdf', 'receipt_pdf']);
export type FileKind = z.infer<typeof FileKind>;
export const FILE_LIMITS: Record<FileKind, { maxBytes: number; types: readonly string[]; uploadable: boolean }> = {
  logo: { maxBytes: 2 * 1024 * 1024, types: ['image/png', 'image/jpeg', 'image/webp'], uploadable: true },
  receipt_image: {
    maxBytes: 8 * 1024 * 1024,
    types: ['image/png', 'image/jpeg', 'image/webp', 'application/pdf'],
    uploadable: true,
  },
  task_photo: { maxBytes: 1024 * 1024, types: ['image/jpeg', 'image/webp'], uploadable: true },
  statement_pdf: { maxBytes: 10 * 1024 * 1024, types: ['application/pdf'], uploadable: false },
  receipt_pdf: { maxBytes: 2 * 1024 * 1024, types: ['application/pdf'], uploadable: false },
};
export const PresignInput = z
  .object({ kind: FileKind, contentType: z.string(), sizeBytes: z.number().int().positive() })
  .superRefine((p, ctx) => {
    const lim = FILE_LIMITS[p.kind];
    if (!lim.uploadable) ctx.addIssue({ code: 'custom', path: ['kind'], message: 'This file type is generated by Boogbe' });
    if (!lim.types.includes(p.contentType))
      ctx.addIssue({ code: 'custom', path: ['contentType'], message: `Allowed: ${lim.types.join(', ')}` });
    if (p.sizeBytes > lim.maxBytes)
      ctx.addIssue({ code: 'custom', path: ['sizeBytes'], message: `Max ${Math.round(lim.maxBytes / 1024)} KB` });
  });
export type PresignInput = z.infer<typeof PresignInput>;
export const PresignResponse = z.object({
  fileId: z.string(),
  uploadUrl: z.string().url(),
  headers: z.record(z.string(), z.string()),
});
export type PresignResponse = z.infer<typeof PresignResponse>;
export const FileUrlResponse = z.object({ url: z.string().url(), expiresAt: z.string() });
export type FileUrlResponse = z.infer<typeof FileUrlResponse>;
